<template>
  <b-form-group
    id="search-field"
    :label="groupLabel"
    class="custom-search-input"
  >
    <multiselect
      :value="value"
      :custom-label="buildItemLabel"
      track-by="id"
      :placeholder="placeholder"
      select-label=""
      deselect-label="remove"
      :options="itemOptions"
      :multiple="multiselect"
      :searchable="true"
      :loading="itemsLoading"
      :internal-search="false"
      :clear-on-select="!multiselect"
      :close-on-select="!multiselect"
      :options-limit="50"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="false"
      :disabled="disabled"
      @search-change="searchItems"
      @input="$emit('input', $event)"
      @remove="itemRemoved"
    />
  </b-form-group>
</template>

<script>
import ResourceAPI from '../services/ResourceAPI';

export default {
  name: 'CustomSearch',
  props: {
    value: {
      type: [Array, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    labelField: {
      type: String,
      default: 'name',
    },
    groupLabel: {
      type: String,
      default: null,
    },
    pathToSearch: {
      type: String,
      default: null,
    },
    with: {
      type: String,
      default: null,
    },
    statuses: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: String,
      default: null,
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    queryParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      itemOptions: [],
      itemsLoading: false,
      awaitingSearch: false,
      searchValue: null,
    };
  },

  created() {
    this.searchItems();
  },

  methods: {
    itemRemoved() {
      this.$emit('input', []);
    },

    // Format item search label
    buildItemLabel(item) {
      if (this.labelField === 'name') {
        return `${item[this.labelField]}`;
      }
      return eval(this.labelField);
    },

    // Search api for items
    searchItems(query) {
      const me = this;

      me.itemsLoading = true;
      me.searchValue = query;

      // Delay search to prevent multiple requests
      // from stacking up when typing
      if (!me.awaitingSearch) {
        setTimeout(() => {
          const data = {
            search: me.searchValue,
            with: me.with,
            statuses: me.statuses.split(','),
            limit: 50,
          };

          ResourceAPI.getRecords(me.pathToSearch, {
            ...data,
            ...me.queryParams,
          }).then((response) => {
            me.itemOptions = response.data;
            me.itemsLoading = false;
            me.awaitingSearch = false;
          });
        }, 300);
      }

      me.awaitingSearch = true;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />
